"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const Button_style_1 = require("./Button.style");
const ActivityIndicator_1 = __importDefault(require("../ActivityIndicator"));
const Text_1 = __importDefault(require("../Text"));
const Button = ({ children, inverted, onClick, onDisabledClick, disabled, white, submitting, title, className, style, noBorder, fullWidth, textSize, small, square, }) => {
    const defaultTextSize = small ? 12 : 16;
    const textSizeProp = textSize ? textSize : defaultTextSize;
    const Container = small ? Button_style_1.SmallButtonContainer : Button_style_1.ButtonContainer;
    return (react_1.default.createElement(Container, { className: className, style: style, inverted: inverted, white: white, disabled: disabled, allowClick: disabled && !!onDisabledClick, onClick: !submitting ? (disabled ? onDisabledClick : onClick) : undefined, noBorder: noBorder, fullWidth: fullWidth, square: square }, submitting ? (react_1.default.createElement(ActivityIndicator_1.default, { small: true, white: !inverted })) : (react_1.default.createElement(Text_1.default, { size: textSizeProp, primary: true, white: (inverted && white && !disabled) || (!inverted && !white && !disabled) }, children || title))));
};
exports.Button = Button;
exports.default = exports.Button;
